import React from 'react';
import Markdown from 'markdown-to-jsx';

export default function MarkdownComponent({ ...rest }) {
  const { externalLinks, children } = rest;

  const overrideLinks = {
    props: {
      target: '_blank',
    },
  };

  // Contentful returns ampersand character as "&#x26;"
  // markdown-to-jsx doesn't compile it as an ampersand
  // that is why replace() method is used
  const childrenWithAmpChar = children.replace(/&#x26;/gi, '&');

  return (
    <Markdown
      {...rest}
      // eslint-disable-next-line react/no-children-prop
      children={childrenWithAmpChar}
      options={{
        overrides: {
          a: externalLinks ? overrideLinks : {},
          p: props => {
            return props?.children?.some(child => typeof child === 'string') ? <p {...props} /> : <div {...props} />;
          },
        },
      }}
    />
  );
}
